export default __webpack_public_path__ + "static/media/Tachometer.16cc2afc.png";